export default {
  code: 'Mã ngạch lương',
  name: 'Tên ngạch lương',
  inactive: 'Ngừng theo dõi',
  List: {
    Title: 'Ngạch lương',
    ActionColumn: 'Chức năng',
  },
};
